import { TOOLS } from "../data/tools.js";
import { mucHopLe } from "../../shared/danhSachMucTieu.js";
import { nguonSoHopLe } from "../../shared/nguonSo.js";
const ids = new Set(TOOLS.map((t) => t.toolId));
const plain = (x) => x !== null && typeof x === "object" && !Array.isArray(x);
function validValues(v) {
  if (!plain(v)) return false;
  const arrays = [
    "rows",
    "holders",
    "safes",
    "rounds",
    "founders",
    "giaDinh",
    "vong",
  ];
  for (const field of arrays)
    if (field in v && (!Array.isArray(v[field]) || !v[field].every(plain)))
      return false;
  if (
    "bangChung" in v &&
    (!Array.isArray(v.bangChung) ||
      !v.bangChung.every((x) => typeof x === "string"))
  )
    return false;
  for (const field of [
    "f",
    "safe",
    "truc",
    "phanBo",
    "daCham",
    "vanBan",
    "round",
  ])
    if (field in v && !plain(v[field])) return false;
  return true;
}
function safe(x, depth = 0) {
  if (depth > 12) return false;
  if (x === null || typeof x === "string" || typeof x === "boolean")
    return true;
  if (typeof x === "number") return Number.isFinite(x);
  if (Array.isArray(x))
    return x.length <= 500 && x.every((v) => safe(v, depth + 1));
  return (
    plain(x) &&
    Object.entries(x).length <= 200 &&
    Object.entries(x).every(
      ([k, v]) =>
        !["__proto__", "constructor", "prototype"].includes(k) &&
        safe(v, depth + 1),
    )
  );
}
/** Bản một trang chỉ liệt kê người sáng lập, không phải toàn bộ nhân sự. */
export const TRAN_DOI_NGU = 6;

/** Trần logo sau khi thu nhỏ. Rộng hơn mức cần, nhưng vẫn chặn được ảnh gốc 5 MB. */
export const TRAN_LOGO = 150000;

/** Logo phải là ảnh dán thẳng vào dữ liệu, đúng định dạng ảnh, và đủ nhẹ. */
export function validLogo(v) {
  if (v === '' || v === null) return true;
  if (typeof v !== 'string') return false;
  if (v.length > TRAN_LOGO) return false;
  return /^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/.test(v);
}

export function validWorkspace(x) {
  if (
    !plain(x) ||
    x.version !== 1 ||
    !plain(x.drafts) ||
    !Array.isArray(x.saved) ||
    !plain(x.tasks) ||
    !safe(x)
  )
    return false;
  if (
    Object.entries(x.drafts).some(
      ([id, d]) =>
        !ids.has(id) ||
        !plain(d) ||
        !validValues(d.values) ||
        typeof d.summary !== "string" ||
        !Number.isFinite(Date.parse(d.updated)),
    )
  )
    return false;
  // Danh sách quỹ mục tiêu: mục cũ chỉ có { id, name } vẫn hợp lệ; các trường
  // theo dõi tiếp cận (đợt, trạng thái, ghi chú) được kiểm độ dài và giá trị.
  // Không chặn theo số lượng ở đây: kho cũ có nhiều mục hơn trần vẫn phải mở được,
  // trần chỉ áp khi thêm mới (themMuc).
  if (x.saved.some((s) => !plain(s) || !mucHopLe(s)))
    return false;
  if (Object.values(x.tasks).some((v) => typeof v !== "boolean")) return false;
  // Bảng dấu xoá và mốc sửa từng ô: chỉ nhận map phẳng chuỗi -> chuỗi thời gian.
  for (const k of ['xoa', 'profileMoc']) {
    if (x[k] === undefined) continue;
    if (!plain(x[k])) return false;
    for (const v of Object.values(x[k])) {
      if (typeof v !== 'string' || Number.isNaN(Date.parse(v))) return false;
    }
  }
  if (x.profile !== undefined) {
    if (!plain(x.profile)) return false;
    // Tên công ty và logo đi vào file xuất ra, nên chặn ngay tại đây: chuỗi quá
    // dài làm vỡ layout bản tóm tắt, và logo phải là ảnh dán thẳng (data URL)
    // chứ không phải đường dẫn http — nếu không, mở file lúc không có mạng là
    // mất logo, và tệ hơn là gọi ra ngoài tới một máy chủ lạ.
    if (x.profile.companyName !== undefined
      && (typeof x.profile.companyName !== 'string' || x.profile.companyName.length > 120))
      return false;
    if (x.profile.logo !== undefined && !validLogo(x.profile.logo)) return false;
    // Nhãn nguồn từng khối số: chỉ nhận toolId có thật, hai mức, tên tài liệu ngắn.
    if (!nguonSoHopLe(x.profile.nguonSo, ids)) return false;
    // Các ô chữ khác cũng đi vào bản một trang. Chuỗi dài bất thường làm vỡ bố
    // cục tài liệu và phình dữ liệu đồng bộ, nên chặn tại đây thay vì tin vào
    // thuộc tính maxLength của ô nhập — bản sao JSON khôi phục vào không đi qua
    // ô nhập nào cả.
    if (x.profile.doiNgu !== undefined) {
      const ds = x.profile.doiNgu;
      if (!Array.isArray(ds) || ds.length > TRAN_DOI_NGU) return false;
      for (const n of ds) {
        if (!plain(n)) return false;
        if (n.ten !== undefined && (typeof n.ten !== 'string' || n.ten.length > 80)) return false;
        if (n.vaiTro !== undefined && (typeof n.vaiTro !== 'string' || n.vaiTro.length > 60)) return false;
        if (n.toanThoiGian !== undefined && typeof n.toanThoiGian !== 'boolean') return false;
        if (n.namNganh !== undefined && n.namNganh !== ''
          && !(Number.isFinite(Number(n.namNganh)) && Number(n.namNganh) >= 0 && Number(n.namNganh) <= 60))
          return false;
      }
    }
    for (const [k, tran] of [['moTa', 200], ['website', 120], ['emailLienHe', 120],
      ['namThanhLap', 8], ['soNhanSu', 8], ['dungVon', 400], ['cotMoc', 250]]) {
      const v = x.profile[k];
      if (v === undefined || v === '') continue;
      if (typeof v !== 'string' && typeof v !== 'number') return false;
      if (String(v).length > tran) return false;
    }
  }
  if (
    x.scenarios !== undefined &&
    (!Array.isArray(x.scenarios) ||
      x.scenarios.length > 20 ||
      x.scenarios.some(
        (s) =>
          !plain(s) ||
          !ids.has(s.tool) ||
          typeof s.id !== "string" ||
          typeof s.name !== "string" ||
          typeof s.summary !== "string" ||
          !validValues(s.values) ||
          !Number.isFinite(Date.parse(s.updated)),
      ))
  )
    return false;
  return true;
}
